import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/mobile_area'
  },
  {
    path: '/mobile_area',
    name: 'mobile_area',
    meta: { title: '携帯キャリアエリアマップ統合版', desc: '携帯キャリア（ドコモ、au、ソフトバンク、楽天モバイル、UQ、Y!モバイル）のエリアマップを重ねて表示できます。' },
    component: () => import('../views/MobileArea.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
